import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15 8V6c0-2.2-1.8-4-4-4H8C5.8 2 4 3.8 4 6v2c-1.105 0-2 .895-2 2v7c0 1.105.895 2 2 2h11c1.105 0 2-.895 2-2v-7c0-1.105-.895-2-2-2zM5 6c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v2H5V6z',
  ],
  height: 20,
  width: 20,
});
